import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    width: '100%',
    // Background comes from Paper (theme.palette.background.paper) via elevation
  },
  profileListItem: {
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  profileContent: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  loginButtonRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  userOptionsList: {
    padding: 0,
  },
  profileName: {
    color: theme.palette.text.primary,
  },
  listItem: {
    color: theme.palette.text.primary,
    textTransform: 'uppercase',
    '&:hover': {
      color: theme.palette.brands?.elevator_red ?? theme.palette.secondary.main,
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
  },
  listItemHighEmphasis: {
    color: theme.palette.text.primary,
    textTransform: 'uppercase',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.brands?.elevator_red ?? theme.palette.secondary.main,
    },
  },
  listDivider: {
    background: theme.palette.divider,
    listStyle: 'none',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  listIcon: {
    color: theme.palette.text.secondary,
    paddingLeft: theme.spacing(1),
  },
  emailText: {
    color: theme.palette.text.secondary,
  },
  lastItem: {
    padding: theme.spacing(2),
  },
  themeToggleHidden: {
    display: 'none',
  },
}));
